import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import './UserAvatar.css';

function UserAvatar({ photoUrl, displayName, size = 'md', className = '' }) {
  const sizeClasses = {
    sm: 'avatar-sm',
    md: 'avatar-md',
    lg: 'avatar-lg'
  };

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const getColorFromName = (name) => {
    if (!name) return '#6c757d';
    const colors = [
      '#0d6efd', '#6610f2', '#6f42c1', '#d63384', '#dc3545',
      '#fd7e14', '#ffc107', '#198754', '#20c997', '#0dcaf0'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <div className={`user-avatar ${sizeClasses[size]} ${className}`}>
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={displayName || 'User'}
          className="avatar-image"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className="avatar-placeholder"
        style={{
          backgroundColor: getColorFromName(displayName),
          display: photoUrl ? 'none' : 'flex'
        }}
      >
        {displayName ? (
          <span className="avatar-initials">{getInitials(displayName)}</span>
        ) : (
          <FontAwesomeIcon icon={faUser} />
        )}
      </div>
    </div>
  );
}

export default UserAvatar;
